import React__default from 'react';
import c from 'classnames';
import Stack from '../../../Stack/Stack.js';
import { SELECT_OPTION_CONFIG } from './consts.js';
import { renderSelectedIndicator } from './renderers.js';

function SelectOption(props) {
  var label = props.label,
    _props$multiple = props.multiple,
    multiple = _props$multiple === void 0 ? false : _props$multiple,
    _props$size = props.size,
    size = _props$size === void 0 ? 'medium' : _props$size,
    state = props.state;
  var config = SELECT_OPTION_CONFIG[size];
  return /*#__PURE__*/React__default.createElement(Stack, {
    alignItems: "center",
    className: c('px-12 w-full', config.Root),
    gapX: 8,
    justifyContent: "between"
  }, label, renderSelectedIndicator({
    config: config,
    multiple: multiple,
    state: state
  }));
}
var SelectOption$1 = /*#__PURE__*/React__default.memo(SelectOption);

export { SelectOption$1 as default };
//# sourceMappingURL=index.js.map
